import { Icon } from "@iconify/react";
import useStore from "../store/zustandstore";
import { useEffect, useRef, useState } from "react";
import "../css/work.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Jelly } from "ldrs/react";
import { getAuth,signOut } from "firebase/auth";
import { useSocketStore } from "../store/socketstore";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import usefbStore from "../store/firebasestore";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";

function Workspace() {
  const urlParam = useParams();
  const userID = usefbStore((s) => s.userID);
  const navigate = useNavigate();
  const setUid = useSocketStore((s) => s.setUid);
  const connected = useSocketStore((s) => s.connected);
  const taskComplete = useSocketStore((s) => s.taskComplete);
  const taskTime = useSocketStore((s) => s.taskTime);
  const completeMethod = useSocketStore((s)=>s.completeMethod);
  const connect = useSocketStore((S) => S.connect);
  const disconnect = useSocketStore((S) => S.disconnect);
  const aIScore = useSocketStore((s)=>s.aIScore);
  const [contentBlock, setContent] = useState("");
  const [factContent, setfactContent] = useState("");
  const translatedText = useRef("");
  const userVerdict = useRef("");
  const factUserExplanation = useRef("");
  const [textotranslate,settextotranslate] = useState("");
  const [inst,setInst] = useState("");
  const payOut = useSocketStore((s)=>s.payOut);
  const hideScreenLoader = useStore((s) => s.hideScreenLoader);
  const [submitTestLoader, setsubmitTestLoader] = useState(false);
  const [originalverdict, setoriginalVerdict] = useState("");
  const [textreference, settextreference] = useState("");
  const [originalExplanation, setoriginalExplanation] = useState("");
  const taskCanceled = useSocketStore((s)=>s.taskCanceled);
  const forceLogout = useSocketStore((s)=>s.forceLogout);
  const [taskType, setTaskType] = useState("");
  const authStatus = usefbStore((s) => s.authStatus);
  const [socketReady, setSocketReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(()=>{
    if(authStatus=="unauthenticated"){
      navigate("/auth");
    }
  },[authStatus]);

  useEffect(() => {
    if (forceLogout) {
      Swal.fire({
        title: "Session Ended",
        text: "Your account has been signed in on another device. For security reasons, this session has been closed.",
        icon: "warning",
        timer: 4000,
        timerProgressBar: true,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didClose: () => {
          const auth = getAuth();
          signOut(auth).then(()=>{
            navigate("/auth");
          }).catch(()=>{
            Swal.fire("Error", "An error occured", "error");
          });
        }
      });
    }
  }, [forceLogout]);

  const rText = useRef(null);
  
  useEffect(()=>{
    if(taskCanceled == true){
      navigate("/dashboard");
    }
  },[taskCanceled]);

  useEffect(()=>{
    if(urlParam.taskType){
      setTaskType(urlParam.taskType);
    }
  },[urlParam.taskType]);


  // Improved socket connection handling
  useEffect(() => {
    if (!userID) return;

    // Set UID first
    setUid(userID);

    // Check if we need to connect or reconnect
    const socketStore = useSocketStore.getState();
    
    if (!socketStore.connected) {
      // Connect with taskId
      connect(urlParam.taskId);
      
      // Set a timeout to check if socket connects
      const connectionTimeout = setTimeout(() => {
        if (!useSocketStore.getState().connected) {
          console.warn("Socket connection timeout");
          Swal.fire({
            title: "Connection Issue",
            text: "Having trouble connecting to the server. Please refresh the page.",
            icon: "warning",
            confirmButtonText: "Refresh",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
        } else {
          setSocketReady(true);
          setIsLoading(false);
        }
      }, 5000);
      
      return () => clearTimeout(connectionTimeout);
    } else {
      // If already connected, make sure we're in the right room
      socketStore.send({
        type: "joinTaskRoom",
        taskId: urlParam.taskId,
        uid: userID,
      });
      setSocketReady(true);
      setIsLoading(false);
    }
    
    // Cleanup on unmount
    return () => {
      // Optional: leave the room when component unmounts
      const currentSocket = useSocketStore.getState();
      if (currentSocket.connected) {
        currentSocket.send({
          type: "leaveTaskRoom",
          taskId: urlParam.taskId,
          uid: userID,
        });
      }
    };
  }, [userID, urlParam.taskId, setUid, connect]);

  // Listen for socket connection status changes
  useEffect(() => {
    if (connected) {
      setSocketReady(true);
      setIsLoading(false);
      
      // Request task data after connection is established
      const socket = useSocketStore.getState();
      socket.send({
        type: "requestTaskData",
        taskId: urlParam.taskId,
        uid: userID,
      });
    } else {
      if (!isLoading) {
        setSocketReady(false);
      }
    }
  }, [connected, urlParam.taskId, userID, isLoading]);

  useEffect(() => {
    if (!userID || !urlParam.taskId) return;
    hideScreenLoader();
    
    const docRef = doc(db, "Users", userID, "assignedTasks", urlParam.taskId);
    const unsub = onSnapshot(docRef, (snap) => {
      if (!snap.exists()) return;
      var st = snap.data().status;
      var task = snap.data().task;
      var instructions = snap.data().instructions;
      setInst(instructions);
      
      if(urlParam.taskType == "Content Review"){
        setContent(task.mainTask.originaltext);
      }
      if(urlParam.taskType == "Content Translation"){
        settextotranslate(task.mainTask.originaltext);
        settextreference(task.mainTask.translatedText);
      }
      if(urlParam.taskType == "Fact Check"){
        setfactContent(task.mainTask.statement);
        setoriginalVerdict(task.mainTask.verdict);
        setoriginalExplanation(task.mainTask.explanation);
      }

      // Optional: only redirect if taskCanceled
      if (st === "Pending" && taskCanceled) {
        navigate(`/workpopup/${urlParam.taskId}/${urlParam.taskType}`);
      }
    });
    
    return () => unsub();
  }, [urlParam.taskId, userID]);

  const backtoDash = () => {
    Swal.fire({
      title: "Are You Leaving?",
      text: "Your progress will be lost!",
      icon: "warning",
      showConfirmButton: true,
      confirmButtonText: "Yes, Leave",
      showCancelButton: true,
      cancelButtonText: "Continue",
      cancelButtonColor: "#6a5acd",
    }).then((result) => {
      if (result.isConfirmed) {
        const socket = useSocketStore.getState();
        socket.send({
          type: "cancelTask",
          taskId: urlParam.taskId,
          uid: userID,
        });
      }
    });
  };

  const currentTaskId = urlParam.taskId;

  const isReady =
    taskComplete === true &&
    currentTaskId === urlParam.taskId &&
    !!completeMethod &&
    payOut !== null &&
    payOut !== undefined;

  useEffect(() => {
    if (!isReady) return;
    navigate(`/complete/${urlParam.taskId}/${completeMethod}/${payOut}/${aIScore}`);
  }, [isReady, navigate, urlParam.taskId, completeMethod, payOut, aIScore]);

  const submmitAitask = () => {
    if(!userID || !urlParam.taskId) return;

    if(urlParam.taskType == "Content Review"){
      if(!rText.current.value){ 
        Swal.fire("Missing Content", "You can't submit a blank input", "warning"); 
        return;
      }
      setsubmitTestLoader(true);
      const socket = useSocketStore.getState();
      socket.send({
        type: "submitTask",
        taskId: urlParam.taskId,
        taskType: urlParam.taskType,
        uid: userID,
        originalText: contentBlock,
        refinedText: rText.current.value,
      });
    }
    
    if(urlParam.taskType == "Fact Check"){
      if(!userVerdict.current.value || !factUserExplanation.current.value){ 
        Swal.fire("Missing Content", "You can't submit a blank input", "warning"); 
        return;
      }
      setsubmitTestLoader(true);
      const socket = useSocketStore.getState();
      socket.send({
        type: "submitTask",
        taskId: urlParam.taskId,
        taskType: urlParam.taskType,
        uid: userID,
        originalverdict: originalverdict,
        originalExplanation: originalExplanation,
        userVerdict: userVerdict.current.value,
        userExplanation: factUserExplanation.current.value,
      });
    }
    
    if(urlParam.taskType == "Content Translation"){
      if(!translatedText.current.value){ 
        Swal.fire("Missing Content", "You can't submit a blank input", "warning"); 
        return;
      }
      setsubmitTestLoader(true);
      const socket = useSocketStore.getState();
      socket.send({
        type: "submitTask",
        taskId: urlParam.taskId,
        taskType: urlParam.taskType,
        uid: userID,
        textotranslate: textreference,
        translatedText: translatedText.current.value,
      });
    }
  };

  // Show loading state while socket is connecting
  if (isLoading || !socketReady) {
    return (
      <div className="workSpaceWrapper">
        <div className="workspacerPlacer">
          <div className="workSpaceNav">
            <div className="wspnLeft" onClick={backtoDash}>
              <p>Back</p>
            </div>
            <div className="wspnRight">
              <Icon className="faIcon" icon="solar:clock-circle-outline" />
              <p>Connecting...</p>
            </div>
          </div>
          <div className="workSpaceCont" style={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            minHeight: "400px" 
          }}>
            <div style={{ textAlign: "center" }}>
              <Jelly size="60" speed="1" color="#6a5acd" />
              <p style={{ marginTop: "20px", color: "#666" }}>
                Connecting to workspace...
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Solara Workspace | Complete Your Task & Earn Rewards</title>
        <meta name="description" content="Complete AI-powered tasks, review content, verify facts, or translate text. Work flexibly, earn rewards, and track your progress on Solara's secure workspace platform." />
        <meta name="keywords" content="Solara workspace, complete tasks, earn online, freelance work, AI tasks, remote work" />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Solara Workspace | Complete Tasks & Earn" />
        <meta property="og:description" content="Your secure workspace to complete tasks, earn rewards, and track your progress on Solara." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Solara Workspace" />
        <meta name="twitter:description" content="Complete your tasks carefully and earn rewards on Solara." />
      </Helmet>
      <div className="workSpaceWrapper">
        <div className="workspacerPlacer">
          <div className="workSpaceNav">
            <div className="wspnLeft" onClick={backtoDash}>
              <p>Back</p>
            </div>
            <div className="wspnRight">
              <Icon className="faIcon" icon="solar:clock-circle-outline" />
              <p>{taskTime || "Loading..."}</p>
            </div>
          </div>
          <div className="workSpaceCont">
            {/* content review workspace  */}
            {taskType == "Content Review" && (
              <div className="workspaceDesk">
                <div className="wsdInstructions">
                  <p><span>TASK:</span> {inst}</p>
                </div>
                <div className="wsdContent">
                  <div className="wsdContentitle">
                    <span>Content</span>
                  </div>
                  <div className="wsdContentParagraph">
                    <p>{contentBlock}</p>
                  </div>
                </div>
                <div className="wsdAnswer">
                  <div className="wsdaAnsTextAreaTitle">
                    <span>Your Correction</span>
                  </div>
                  <div className="wsdaAnsTextArea">
                    <textarea
                      name=""
                      id=""
                      placeholder="Type your correction here"
                      ref={rText}
                    ></textarea>
                  </div>
                </div>
              </div>
            )}
            
            {taskType == "Fact Check" && (
              <div className="workspaceDesk">
                <div className="wsdInstructions">
                  <p><span>TASK:</span> {inst}</p>
                </div>
                <div className="wsdFactStatement">
                  <div className="wsdContentitle">
                    <span>Statement</span>
                  </div>
                  <div className="wsdContentFactStatement">
                    <p>{factContent}</p>
                  </div>
                </div>
                <div className="wsdContentLittle">
                  <div className="wsdContentitle">
                    <span>Your Verdict</span>
                  </div>
                  <div className="wsdContentParagraphwsdContentLittle">
                    <select name="" id="" ref={userVerdict}>
                      <option value="">Select verdict</option>
                      <option value="True">True</option>
                      <option value="False">False</option>
                    </select>
                  </div>
                </div>
                <div className="wsdAnswer">
                  <div className="wsdaAnsTextAreaTitle">
                    <span>Your Explanation</span>
                  </div>
                  <div className="wsdaAnsTextArea">
                    <textarea
                      name=""
                      id=""
                      placeholder="Type your correction here"
                      ref={factUserExplanation}
                    ></textarea>
                  </div>
                </div>
              </div>
            )}
            
            {taskType == "Content Translation" && (
              <div className="workspaceDesk">
                <div className="wsdInstructions">
                  <p><span>TASK:</span> {inst}</p>
                </div>
                <div className="wsdContent">
                  <div className="wsdContentitle">
                    <span>Original Content</span>
                  </div>
                  <div className="wsdContentParagraph">
                    <textarea name="" readOnly value={textotranslate}></textarea>
                  </div>
                </div>
                <div className="wsdAnswer">
                  <div className="wsdaAnsTextAreaTitle">
                    <span>Your Translation</span>
                  </div>
                  <div className="wsdaAnsTextArea">
                    <textarea
                      name=""
                      id=""
                      placeholder="Type your translation here"
                      ref={translatedText}
                    ></textarea>
                  </div>
                </div>
              </div>
            )}

            <div className="workspacebtn">
              {submitTestLoader ? (
                <div className="workspaceBtnloader">
                  <Jelly size="45" speed="1" color="#6a5acd"></Jelly>
                </div>
              ) : (
                <button onClick={submmitAitask}>Submit</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Workspace;